<aside
    class="tw-w-full tw-z-[9991] xl:tw-w-[260px] tw-fixed tw-top-0 xl:tw-block xl:tw-static xl:tw-translate-x-0 tw-transition-all tw-border-r tw-border-[#00000033] tw-p-[20px] md:tw-p-3 xl:tw-p-[20px] tw-h-full tw-bg-white tw-flex tw-flex-col"
    [ngClass]="{
        'tw-translate-x-0 tw-overflow-auto  md:!tw-w-[256px] md:!-tw-translate-x-[70px]':
            isOpen,
        '-tw-translate-x-full md:tw-w-[70px] tw-overflow-auto': !isOpen
    }"
>
    <div class="tw-flex tw-flex-col tw-flex-1">
        <div
            class="xl:tw-hidden tw-border-b tw-pt-[9px] tw-pb-[19px] tw-flex tw-justify-between"
        >
            <mat-icon
                class="tw-w-[28px] tw-h-[28px]"
                style="color: #d0d1d2"
                (click)="toggleSidebar.emit()"
                [ngClass]="{ 'tw-mx-auto': !isOpen, 'tw-m-0': isOpen }"
                >menu</mat-icon
            >
            <mat-icon
                class="!tw-text-[#4B6EEC] !tw-w-[16px] !tw-h-[16px] !tw-leading-[20px] !tw-pr-[22px]"
                [ngClass]="{
                    '!tw-hidden': !isOpen,
                    '!tw-inline-block': isOpen
                }"
                (click)="toggleSidebar.emit()"
                >keyboard_arrow_left</mat-icon
            >
        </div>
        <div
            class="tw-w-full xl:tw-w-[210px] tw-mx-auto tw-items-center"
            [ngClass]="{ 'tw-mt-[14px]': isOpen, 'tw-mt-0': !isOpen }"
        ></div>
        <div
            class="userprofile md:tw-hidden xl:!tw-flex tw-rounded-xl tw-p-5 tw-h-[190px] tw-flex tw-flex-col tw-items-center tw-gap-1 tw-bg-[#EEF4FF] tw-mb-5"
            [ngClass]="{ 'md:!tw-hidden': !isOpen, 'md:!tw-flex': isOpen }"
        >
            <img
                [src]="previewImageUrl"
                class="tw-h-[94px] tw-w-[94px] tw-min-h-[94px] tw-rounded-full tw-border-[1px] tw-border-gray-400"
                alt="User Image"
            />
            <div class="tw-text-center tw-flex tw-flex-col">
                <span
                    class="!tw-mb-0 !tw-leading-[1] !tw-font-bold !tw-text-[18px]"
                >
                    {{ userData?.username }}
                </span>
                <span class="tw-text-sm tw-text-[#000000B2]">{{
                    userData?.details?.bizname
                }}</span>
            </div>

            <a
                routerLink="/profile"
                class="tw-font-bold tw-underline tw-text-[#FF8819] tw-text-sm tw-cursor-pointer"
                >{{ "DASHBOARD.DASHBOARD_SIDEBAR.VIEW_PROFILE" | translate }}</a
            >
        </div>

        <div
            class="tw-hidden xl:tw-flex tw-flex-col tw-gap-2 tw-p-4 tw-rounded-xl tw-border tw-border-[#FF8819] tw-mb-5 tw-cursor-pointer"
            (click)="onClickCompleteProfile()"
            *ngIf="profileCompletionPercent < 100"
        >
            <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
                <span class="!tw-text-sm">
                    {{ "DASHBOARD.COMPLETE_PROFILE" | translate }}
                </span>
                <img
                    src="assets/images/dashboard/icons/side-arrow.svg"
                    class="tw-h-[22px] tw-w-[22px]"
                />
            </div>

            <mat-progress-bar
                mode="determinate"
                [value]="profileCompletionPercent"
            ></mat-progress-bar>
            <span class="tw-text-[18px] tw-font-semibold"
                >{{ profileCompletionPercent }}%</span
            >
        </div>

        <div class="tw-my-[14px]">
            <ul class="tw-flex tw-flex-col tw-gap-3">
                <li *ngFor="let item of menuData">
                    <a
                        [attr.ga-event-id]="
                            item.ga_event_id + '_text_dashboard_click'
                        "
                        ga-event-category="User Dashboard Button"
                        [attr.ga-event-label]="
                            (item.name | translate) + ' Text Click'
                        "
                        ga-track="track"
                        [routerLink]="item?.route"
                        class="tw-flex tw-items-center tw-font-semibold tw-text-[16px] tw-text-[#0A0A75] tw-gap-2 tw-h-full tw-w-full tw-p-[10px] tw-rounded-[12px]"
                        (click)="setActiveRoute(item.route)"
                        [ngClass]="{
                            'tw-bg-[#FF8819] tw-text-white':
                                item.route === activeRoute
                        }"
                    >
                        <div class="tw-relative">
                            <span
                                *ngIf="
                                    item?.route === '/notifications' &&
                                    haveNotifications
                                "
                                class="tw-min-w-[6px] tw-min-h-[6px] tw-rounded-full tw-bg-[#FF1212] tw-absolute tw-top-[4px] tw-right-[6px]"
                            ></span>
                            <div class="tw-h-[24px] tw-w-[24px]">
                                <img
                                    class="tw-h-[24px] tw-w-[24px]"
                                    [src]="
                                        item.route === activeRoute
                                            ? item?.icon.light
                                            : item?.icon.dark
                                    "
                                    alt="Complete Icon"
                                />
                            </div>
                        </div>
                        <span
                            [ngClass]="{
                                'md:!tw-hidden': !isOpen,
                                'md:!tw-inline': isOpen
                            }"
                            class="md:tw-hidden xl:!tw-inline tw-inline"
                            >{{ item?.name | translate }}</span
                        >
                    </a>
                </li>
            </ul>
        </div>
        <div [ngClass]="{ 'tw-hidden': isOpen, 'tw-block': !isOpen }">
            <hr class="tw-border-[#00000024] tw-mb-5" />

            <div class="tw-mb-5">
                <ul class="tw-flex tw-flex-col tw-gap-[6px]">
                    <li *ngFor="let item of subRoutes">
                        <a
                            [attr.ga-event-id]="
                                item.ga_event_id + '_text_dashboard_click'
                            "
                            ga-event-category="User Dashboard Button"
                            [attr.ga-event-label]="
                                (item.name | translate) + ' Text Click'
                            "
                            ga-track="track"
                            [routerLink]="item?.route"
                            class="tw-flex tw-text-[16px] tw-items-center tw-font-semibold tw-text-[#000000B2] tw-gap-2 tw-h-full tw-w-full tw-p-[10px]"
                            (click)="setActiveRoute(item.route)"
                            [ngClass]="{
                                'tw-text-[#FF8819] tw-bg-white':
                                    item.route === activeRoute
                            }"
                        >
                            <img
                                class="tw-hidden md:tw-inline xl:tw-hidden"
                                [src]="item.img"
                                [alt]="item.name"
                            />
                            <span
                                [ngClass]="{
                                    'md:!tw-hidden': !isOpen,
                                    'md:!tw-inline': isOpen
                                }"
                                class="md:tw-hidden xl:!tw-inline tw-inline"
                                >{{ item?.name | translate }}</span
                            >
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Bottom section that will stick to the bottom -->
    <div
        [ngClass]="{ 'tw-hidden': !isOpen, 'tw-block': isOpen }"
        class="tw-px-[20px] tw-mt-auto"
    >
        <hr class="tw-border-[#000] tw-mb-5" />

        <div class="tw-mb-5">
            <ul class="tw-flex tw-flex-col tw-gap-[14px]">
                <li *ngFor="let item of subRoutes">
                    <a
                        [attr.ga-event-id]="
                            item.ga_event_id + '_text_dashboard_click'
                        "
                        ga-event-category="User Dashboard Button"
                        [attr.ga-event-label]="
                            (item.name | translate) + ' Text Click'
                        "
                        ga-track="track"
                        [routerLink]="item?.route"
                        class="tw-flex tw-text-sm tw-items-center tw-text-[#000000B2] tw-gap-2 tw-h-full tw-w-full"
                        (click)="setActiveRoute(item.route)"
                        [ngClass]="{
                            'tw-text-[#FF8819] tw-bg-white':
                                item.route === activeRoute
                        }"
                    >
                        <span
                            [ngClass]="{
                                'md:!tw-hidden': !isOpen,
                                'md:!tw-inline': isOpen
                            }"
                            class="md:tw-hidden xl:!tw-inline tw-inline"
                            >{{ item?.name | translate }}</span
                        >
                    </a>
                </li>
                <li>
                    <button
                        [attr.ga-event-id]="gtmTags?.Log_Out?.event"
                        [attr.ga-event-category]="
                            gtmTags?.Log_Out?.event_category
                        "
                        [attr.ga-event-label]="gtmTags?.Log_Out?.event_label"
                        ga-track="track"
                        class="tw-flex tw-text-sm tw-items-center tw-text-[#000000B2] tw-gap-2 tw-h-full tw-w-full"
                        (click)="authService.signOut()"
                    >
                        <span
                            [ngClass]="{
                                'md:!tw-hidden': !isOpen,
                                'md:!tw-inline': isOpen
                            }"
                            class="md:tw-hidden xl:!tw-inline tw-inline"
                            >{{ "COMMON.LOGOUT" | translate }}</span
                        >
                    </button>
                </li>
            </ul>
        </div>
    </div>
</aside>
